// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__26t50","upload":"Small_upload__2_ST7","imageWrap":"Small_imageWrap__zW6T9","removeBtn":"Small_removeBtn__3soj6"};